
import RocketIcon from '@/components/CustomIcons/RocketIcon.vue';


export default {
	name: 'NavMenubar',
	components: { RocketIcon },
	data () {
		return {
			baseURL: process.env.NUXT_APP_PANEL_BASE_URL,
		};
	},
	computed: {
		menuItems ()
		{
			return [
				{ name: 'Markets',     route: this.baseURL + '/markets',        type: 'external', icon: require('@/assets/icons/nav-markets.svg')     },
				{ name: 'Trade',       route: this.baseURL + '/exchange',       type: 'external', icon: require('@/assets/icons/nav-trade.svg')       },
				{ name: 'Futures',     route: '#', class: 'coming-soon',        type: 'inactive', icon: require('@/assets/icons/nav-futures.svg')     },
				{ name: 'EZ Convert',  route: this.baseURL + '/convert',        type: 'external', icon: require('@/assets/icons/nav-convert.svg')     },
				{ name: 'Staking',     route: this.baseURL + '/staking',        type: 'external', icon: require('@/assets/icons/nav-staking.svg')     },
				{ name: 'Help Center', route: 'https://helpcenter.enifex.com/', type: 'external', icon: require('@/assets/icons/nav-help-center.svg') },
			];
		},
	},
	methods: {
		isLogin ()
		{
			return (typeof window == 'undefined' ? false : !!window.localStorage.getItem('Enifex.AccessToken'));
		},
	},
}
